var fontFamily = {
  name: "Azo Sans, sans-serif",
  href: "//static.home.pl/static/assets/azo-sans.css"
};
export default fontFamily;